import {RefObject} from 'react';
import {CircleCheck} from 'lucide-react';
import {cn, Webcam, WebcamRefTypes} from '@chekin/guestapp-ui-kit';
import styles from './styles.module.css';
import {useTranslation} from 'react-i18next';
import {useErrorModal} from '@chekin/shared';

interface IVQRScannerDesktopViewProps {
  webcamRef: RefObject<WebcamRefTypes>;
  showSuccessIcon: boolean;
  handleUserMedia: () => void;
}

function IVQRScannerDesktopView({
  webcamRef,
  showSuccessIcon,
  handleUserMedia,
}: IVQRScannerDesktopViewProps) {
  const {t} = useTranslation('identity-verification');
  const {displayError, ErrorModal} = useErrorModal();

  return (
    <div className={styles.ivQRScanner_content}>
      <div className={styles.ivQRScanner_header}>
        <h2 className={styles.ivQRScanner_title}>{t('scan_qr_code')}</h2>
        <p className={styles.ivQRScanner_subtitle}>
          {t('position_qr_code_inside_frame')}
        </p>
      </div>

      <div className={styles.ivQRScanner_webcam}>
        <Webcam
          ref={webcamRef}
          onUserMedia={handleUserMedia}
          hideScanArea={false}
          cropToScanArea
          videoConstraints={{
            facingMode: 'environment',
          }}
          onError={displayError}
        />
      </div>

      <div
        className={cn(
          styles.ivQRScanner_successIcon,
          showSuccessIcon && styles.ivQRScanner_successIconShown,
        )}
      >
        <CircleCheck size={72} color="#20C997" />
      </div>
      <ErrorModal />
    </div>
  );
}

export {IVQRScannerDesktopView};
